const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

export default function Stepper({ step, onGoToDate }) {
  return (
    <div className="stepper">
      <div
        className={`step ${step === 0 ? 'step--active' : 'step--done'}`}
        onClick={step === 1 ? onGoToDate : undefined}
        style={step === 1 ? { cursor: 'pointer' } : undefined}
      >
        <div className="step-circle">{step > 0 ? <CheckIcon /> : '1'}</div>
        <div className="step-label">
          {step === 0 ? <strong>Scegli<br />la data</strong> : <>Scegli<br />la data</>}
        </div>
      </div>
      <div className={`step-line ${step > 0 ? 'step-line--done' : ''}`} />
      <div className={`step ${step === 1 ? 'step--active' : step > 1 ? 'step--done' : ''}`}>
        <div className="step-circle">{step > 1 ? <CheckIcon /> : '2'}</div>
        <div className="step-label">
          {step === 1 ? <strong>Seleziona<br />il posto</strong> : <>Seleziona<br />il posto</>}
        </div>
      </div>
      <div className={`step-line ${step > 1 ? 'step-line--done' : ''}`} />
      <div className={`step ${step === 2 ? 'step--active' : step > 2 ? 'step--done' : ''}`}>
        <div className="step-circle">{step > 2 ? <CheckIcon /> : '3'}</div>
        <div className="step-label">
          {step === 2 ? <strong>Conferma<br />e paga</strong> : <>Conferma<br />e paga</>}
        </div>
      </div>
    </div>
  )
}
